import React from 'react'
import ReactModal from 'react-modal'

const GenericErrorModal = ({ children, isOpen, toggleModal, withOpen }) => {
  return (
    <div>
      <ReactModal
        className='react-modal error-modal generic'
        onRequestClose={toggleModal}
        isOpen={isOpen}
        appElement={document.querySelector('#root')}
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
        style={{ overlay: { background: 'rgba(60,59,59,0.75)' }}}>
        <div className='generic-error-modal-header'>
          <i className='fa fa-times-thin fa-2x' onClick={toggleModal}></i>
        </div>
        {children}
        <div className='button-container'>
          {withOpen && <button
            className='eblue-button open-chat-window'
            onClick={() => toggleModal(true)}>
            OPEN LIVECHAT
          </button>}
          <hr/>
          <button
            className='btn btn-danger close-modal'
            onClick={toggleModal}>
            CLOSE
          </button>
        </div>
      </ReactModal>
    </div>
  )
}

export default GenericErrorModal
